import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import { router } from './main';
import { config } from './config';

Vue.use(Vuex);

// STATE
const state = {
    err404:                 false,
    loading:                true,
    loadingData:            true,
    serverDateTime:         null,
    interactive: {
        loaded:             false,
        pixiApp:            null,
        entered:            false,
        transitioned:       false,
        zoomed:             false,
        powerSurgeEnabled:  false,
        powerSurge:         false,
        powerSurgeOverlay:  false,
        activePanel:        null,
        activeShare:        false,
        panelOpen:          false,
        lastExposure:       null,
        instructed:         false
    },
    globals:                [],
    company:                {},
    exposures:              [],
    exposureData:           [],
    usStates:               [],
    canadianProvinces:      [],
    google: {
        recaptcha: {
            siteKey:        '6Ld61i0UAAAAAOIf5Nuj-32Np374MWrLDTM1FBMe',
            theme:          'light',
            type:           'image',
            size:           'normal',
            tabindex:       50,
            callback:       null,
            expCallback:    null
        }
    }
};


// ACTIONS
const actions = {

    LOAD_APP_DATA: ({ state, commit }) => {
        //console.info('%cLOAD_APP_DATA', 'color:aqua;');

        let _apiURLEnv = process.env.API_URL;

        let _apiURL = (router.history.current.query.id) ? _apiURLEnv + '?id=' + router.history.current.query.id : _apiURLEnv;


        //////////////
        // get us state data
        axios.get(config.usStateData).then((res) => {
            // set us state data
            commit('SET_US_STATE_DATA', { val: res.data });
        }, (err) => {
            console.error(err);
        });
        //////////////


        //////////////
        // get canadian province data
        axios.get(config.canadianProvinceData).then((res) => {
            // set canadian province data
            commit('SET_CANADIAN_PROVINCE_DATA', { val: res.data });
        }, (err) => {
            console.error(err);
        });
        //////////////


        //////////////
        // get static exposure data
        axios.get(config.staticExposureData).then((_res) => {

            // set static exposure data
            commit('SET_EXPOSURE_DATA', { val: _res.data });

            //////////////
            // get app live api data
            axios.get(_apiURL).then((res) => {

                // set 404 error if we do not get data back from the api
                if (!res.data || res.data <= '') {
                    commit('SET_404', { val: true });
                    return new Promise(() => {});
                } else {
                    commit('SET_404', { val: false });
                }

                let appData = res.data;

                commit('SET_COMPANY_DATA', { company: appData });

                function merge(a, b, id, keys) {
                    let array = [], object = {};

                    function m(c) {
                        if (!object[c[id]]) {
                            object[c[id]] = {};
                            object[c[id]][id] = c[id];
                            array.push(object[c[id]]);
                        }
                        keys.forEach(function(k) {
                            if (k in c) { object[c[id]][k] = c[k]; }
                        });
                    }
                    a.forEach(m);
                    b.forEach(m);
                    return array;
                }

                // merge exposures with exposureData (static positions + animations)
                let _mergedExposures = merge(state.company.occupancies[0].exposures, state.exposureData, 'exposure_slug', ['coverage', 'x', 'y', 'animation', 'exposure_id', 'exposure_type', 'exposure_name', 'exposure_label', 'hazard', 'lead_in', 'loss_example', 'maintenance_tip', 'pdf', 'media', 'enabled', 'graphic', 'mobile']);
                commit('SET_EXPOSURES', { val: _mergedExposures });
                commit('SET_EXPOSURE_DATA', { val: _mergedExposures });

                // merge coverages with exposureData (static positions + animations)
                let _mergedCoverages = merge(state.company.occupancies[0].coverages, state.exposureData, 'exposure_slug', ['coverage', 'x', 'y', 'animation', 'exposure_id', 'exposure_type', 'exposure_name', 'exposure_label', 'hazard', 'lead_in', 'loss_example', 'maintenance_tip', 'pdf', 'media', 'enabled', 'graphic', 'mobile']);
                commit('SET_EXPOSURES', { val: _mergedCoverages });
                commit('SET_EXPOSURE_DATA', { val: _mergedCoverages });

                commit('SET_LOADING', { val: false });
                commit('SET_LOADING_DATA', { val: false });

            }, (err) => {
                console.error(err);
                commit('SET_404', { val: true });
            });
            //////////////

        }, (err) => {
            console.error(err);
            commit('SET_404', { val: true });
        });
        //////////////

    },

    STATUS_404: ({ state, commit }, payload) => {
        commit('SET_404', { val: payload.val });
    },

    INTERACTIVE: ({ state, commit }, payload) => {
        commit('SET_INTERACTIVE', { val: payload.val });
    },

    LOADED: ({ state, commit }, payload) => {
        commit('SET_LOADED', { val: payload.val });
    },

    ENTER_INTERACTIVE: ({ state, commit }, payload) => {
        commit('SET_ENTERED', { val: payload.val });
    },

    TRANSITION_INTERACTIVE: ({ state, commit }, payload) => {
        commit('SET_TRANSITIONED', { val: payload.val });
    },

    INSTRUCTED: ({ state, commit }, payload) => {
        commit('SET_INSTRUCTED', { val: payload.val });
    },

    ZOOM_INTERACTIVE: ({ state, commit }, payload) => {
        commit('SET_ZOOMED', { val: payload.val });
    },

    POWER_SURGE: ({ state, commit }, payload) => {
        commit('SET_POWER_SURGE', { val: payload.val });
    },

    POWER_SURGE_STATE: ({ state, commit }, payload) => {
        commit('SET_POWER_SURGE_STATE', { val: payload.val });
    },

    POWER_SURGE_OVERLAY: ({ state, commit }, payload) => {
        commit('SET_POWER_SURGE_OVERLAY', { val: payload.val });
    },

    ACTIVE_PANEL: ({ state, commit }, payload) => {
        commit('SET_ACTIVE_PANEL', { val: payload.val });
    },

    PANEL_OPEN: ({ state, commit }, payload) => {
        commit('SET_PANEL_OPEN', { val: payload.val });
    },

    ACTIVE_SHARE: ({ state, commit }, payload) => {
        commit('SET_ACTIVE_SHARE', { val: payload.val });
    },

    LAST_EXPOSURE_ANIMATION: ({ state, commit }, payload) => {
        commit('SET_LAST_EXPOSURE', { val: payload.val })
    }

};


// MUTATIONS
const mutations = {

    SET_COMPANY_DATA: (state, { company }) => {
        state.company = company;
    },

    SET_LOADING: (state, { val }) => {
        state.loading = val;
    },

    SET_LOADING_DATA: (state, { val }) => {
        state.loadingData = val;
    },

    SET_404: (state, { val }) => {
        state.err404 = val;
    },

    SET_INTERACTIVE: (state, { val }) => {
        state.interactive.pixiApp = val;
    },

    SET_LOADED: (state, { val }) => {
        state.interactive.loaded = val;
    },

    SET_ENTERED: (state, { val }) => {
        state.interactive.entered = val;
    },

    SET_TRANSITIONED: (state, { val }) => {
        state.interactive.transitioned = val;
    },

    SET_INSTRUCTED: (state, { val }) => {
        state.interactive.instructed = val;
    },

    SET_ZOOMED: (state, { val }) => {
        state.interactive.zoomed = val;
    },

    SET_POWER_SURGE: (state, { val }) => {
        state.interactive.powerSurge = val;
    },

    SET_POWER_SURGE_STATE: (state, { val }) => {
        state.interactive.powerSurgeState = val;
    },

    SET_POWER_SURGE_OVERLAY: (state, { val }) => {
        state.interactive.powerSurgeOverlay = val;
    },

    SET_ACTIVE_PANEL: (state, { val }) => {
        state.interactive.activePanel = val;
    },

    SET_PANEL_OPEN: (state, { val }) => {
        state.interactive.panelOpen = val;
    },

    SET_ACTIVE_SHARE: (state, { val }) => {
        state.interactive.activeShare = val;
    },

    SET_EXPOSURE_DATA: (state, { val }) => {
        state.exposureData = val;
    },

    SET_EXPOSURES: (state, { val }) => {

        let _array = [];

        // filter exposures for enabled status
        _.each(val, function(_val) {
            if (_.find(state.company.occupancies[0].exposures, { 'exposure_slug': _val.exposure_slug })) {
                _val.enabled = true;
                _array.push(_val);
            } else if (_.find(state.company.occupancies[0].coverages, { 'exposure_slug': _val.exposure_slug })) {
                _val.enabled = true;
                _array.push(_val);
            }
        });

        state.exposures = _array;
    },

    SET_LAST_EXPOSURE: (state, { val }) => {
        state.interactive.lastExposure = val;
    },

    SET_US_STATE_DATA: (state, { val }) => {
        state.usStates = val;
    },

    SET_CANADIAN_PROVINCE_DATA: (state, { val }) => {
        state.canadianProvinces = val;
    }

};


// GETTERS
const getters = {

    getParams: state => {
        return state.route.params;
    },

    get404Status: state => {
        return state.err404;
    },

    getInteractive: state => {
        return state.interactive.pixiApp;
    },

    getLoadedState: state => {
        return state.interactive.loaded;
    },

    getEnteredState: state => {
        return state.interactive.entered;
    },

    getTransitionedState: state => {
        return state.interactive.transitioned;
    },

    getInstructedState: state => {
        return state.interactive.instructed;
    },

    getZoomedState: state => {
        return state.interactive.zoomed;
    },

    getActivePanel: state => {
        return state.interactive.activePanel;
    },

    getPanelState: state => {
        return state.interactive.panelOpen;
    },

    getActiveShare: state => {
        return state.interactive.activeShare;
    },

    getPowerSurge: (state, getters) => {
        return _.filter(getters.getOccupancies.other, { 'exposure_slug': 'power-surge' })
    },

    getPowerSurgeState: state => {
        return state.interactive.powerSurge;
    },

    getPowerSurgeOverlayState: state => {

        return state.interactive.powerSurgeOverlay;

    },

    getPowerSurgeAnimations: (state, getters) => {
        return _.filter(getters.getExposures, function(o) {
            return (o.animation.enabled === true && o.animation.powerGrid === true);
        });
    },

    getReCaptchaConfig: state => {
        return state.google.recaptcha;
    },

    getCompany: state => {
        return state.company;
    },

    getCompanyLogo: (state, getters) => {
        let _logo = getters.getCompany;
        _logo = _logo.logo;
        return _logo;
    },

    getCompanyPDF: state => {
        return state.company.company_info_pdf;
    },

    getAboutPosition: state => {
        return state.company.about_button_placement;
    },

    getPrivacyData: state => {
        return state.company.privacy;
    },

    getTermsData: state => {
        return state.company.disclaimer;
    },

    getLandingData: state => {
        let _obj = {};
        _obj.title = state.company.landing_title;
        _obj.intro = state.company.landing_intro;
        _obj.tagline = state.company.landing_tagline;
        return _obj;
    },

    getCompanyContactData: state => {
        let _obj = {};
        _obj.slug = state.company.slug;
        _obj.name = state.company.company_name;
        _obj.email = state.company.contact_dest;
        _obj.address1 = state.company.address1;
        _obj.address2 = state.company.address2;
        _obj.city = state.company.city;
        _obj.state = state.company.state;
        _obj.zipcode = state.company.zip;
        _obj.phone = state.company.phone;
        _obj.fax = state.company.fax;
        _obj.form_label = state.company.contact_label;
        _obj.form_header = state.company.contact_text;
        _obj.form_intro = state.company.contact_intro;
        _obj.form_type = state.company.contact_form_type;
        _obj.form_fields = state.company.contact_form_fields;
        _obj.form_thanks_title = state.company.contact_thank_you_heading;
        _obj.form_thanks_msg = state.company.contact_thank_you_msg;
        _obj.contact_title = state.company.contact_text;
        _obj.show_company_name = state.company.company_name_show;
        return _obj;
    },

    getAboutContent: (state, getters) => {
        let _obj = {};
        _obj.about_label = state.company.about_label;
        _obj.about_heading_1 = state.company.about_heading_1;
        _obj.about_body_1 = state.company.about_body_1;
        _obj.about_heading_2 = state.company.about_heading_2;
        _obj.about_body_2 = state.company.about_body_2;
        return _obj;
    },

    getOccupancies: state => {
        return state.company.occupancies[0];
    },

    getExposureData: state => {
        return state.exposureData;
    },

    getExposures: state => {
        return state.exposures;
    },

    getExposureBySlug: (state, getters) => (slug) => {
        return _.find(getters.getExposures, { 'exposure_slug': slug });
    },

    getLastExposure: state => {
        return state.interactive.lastExposure;
    },

    getExposureDisclaimer: state => {
        return state.company.occupancies[0].occupancy_exposure_disclaimer;
    },

    getAdditionalCoveragesLabel: state => {
        return state.company.occupancies[0].occupancy_additional_coverages_label;
    },

    getServiceLineCoverageLabel: state => {
        return state.company.occupancies[0].occupancy_service_line_coverage_label;
    },

    getOffPremiseCoverageLabel: state => {
        return state.company.occupancies[0].occupancy_off_premise_coverage_label;
    },

    getCoverages: (state, getters) => {
        return _.filter(getters.getExposures, { 'coverage': true });
    },

    getServiceLineCoverages: (state, getters) => {
        return _.filter(getters.getExposures, function(o) {
            return (o.enabled === true && o.coverage === true && o.exposure_type === 'service-line');
        });
    },

    getOffPremisesCoverages: (state, getters) => {
        return _.filter(getters.getExposures, function(o) {
            return (o.enabled === true && o.coverage === true && o.exposure_type === 'off-premise');
        });
    },

    getCoveragesByType: (state, getters) => (type) => {
        return _.filter(getters.getCoverages, { 'exposure_type': type });
    },

    getCoverageContent: (state) => {
        let obj = {};
        obj.cta_offpremise = state.company.occupancies[0].occupancy_off_premise_coverage_cta;
        obj.cta_serviceline = state.company.occupancies[0].occupancy_service_line_coverage_cta;
        return obj;
    },

    getPowerSurgeData: state => {
        return _.find(state.company.occupancies[0].other, { 'exposure_slug': 'power-surge' });
    },

    getUSStateData: state => {
        return state.usStates;
    },

    getCanadianProvinceData: state => {
        return state.canadianProvinces;
    },

    getShareData: state => {
        return state.company.social_sharing;
    }

};


// MODULES
const modules = {

};


export default new Vuex.Store({
    state,
    actions,
    mutations,
    getters,
    modules
});


// WEBPACK FOOTER //
// ./src/store.js